export default "__VITE_ASSET__ebba4428__"